document.addEventListener('DOMContentLoaded', () => {
  const openBtns = document.querySelectorAll('.find-your-size-btn');

  const modal = document.getElementById('FindYourSizeModal');
  const closeBtn = document.querySelector('.fys-close-btn');
  const form = document.getElementById('FindYourSizeForm');
  const resultContainer = document.getElementById('FindYourSizeResult');
  const resultValue = document.getElementById('fys-result-val');
  const errorContainer = document.getElementById('FindYourSizeError');
  const sizeGuideDataScript = document.getElementById('SizeGuideDataJSON');
  
  if (!modal || !form || !sizeGuideDataScript) return;

  let sizeData = [];
  try {
    sizeData = JSON.parse(sizeGuideDataScript.textContent);
  } catch(e) {
    console.error("Size data could not be parsed.", e);
  }

  // Modal Open/Close Logic
  openBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      modal.showModal();
      document.body.style.overflow = 'hidden';
    });
  });

  const closeModal = () => {
    modal.close();
    document.body.style.overflow = '';
  };

  closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  // Calculate Size Logic
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    
    // Hide previous states
    resultContainer.classList.add('hidden');
    errorContainer.classList.add('hidden');

    const chest = parseFloat(document.getElementById('fys-chest').value);
    const waist = parseFloat(document.getElementById('fys-waist').value);
    const hips = parseFloat(document.getElementById('fys-hips').value);

    if (isNaN(chest) || isNaN(waist) || isNaN(hips) || chest <= 0 || waist <= 0 || hips <= 0) {
      alert("Lütfen geçerli ve pozitif ölçüler giriniz.");
      return;
    }

    if (sizeData.length === 0) {
      alert("Beden tablosu verisi bulunamadı.");
      return;
    }

    // Check if any measurement exceeds the max available size in the chart
    // We assume the last element in sizeData is the maximum size (e.g. 50)
    const maxSize = sizeData[sizeData.length - 1];
    if (chest > maxSize.chest || waist > maxSize.waist || hips > maxSize.hips) {
      errorContainer.classList.remove('hidden');
      return;
    }

    // Find min required size for each measurement
    let chestSize = 0;
    let waistSize = 0;
    let hipsSize = 0;

    for (let i = 0; i < sizeData.length; i++) {
      const row = sizeData[i];
      if (chestSize === 0 && chest <= row.chest) chestSize = row.size;
      if (waistSize === 0 && waist <= row.waist) waistSize = row.size;
      if (hipsSize === 0 && hips <= row.hips) hipsSize = row.size;
    }

    // If a measurement was larger than anything (but we already checked against max), this is a fallback.
    if (chestSize === 0) chestSize = maxSize.size;
    if (waistSize === 0) waistSize = maxSize.size;
    if (hipsSize === 0) hipsSize = maxSize.size;

    // The final recommended size is the maximum of the three required sizes
    const recommendedSize = Math.max(chestSize, waistSize, hipsSize);

    resultValue.textContent = recommendedSize;
    resultContainer.classList.remove('hidden');
  });

  form.addEventListener('reset', () => {
    resultContainer.classList.add('hidden');
    errorContainer.classList.add('hidden');
  });
});
